import { useEffect, useRef, useState } from "react";
import CustomSelector from "../../shared/customSelector";
import {
  Modal,
  Form,
  Container,
  Content,
  Button,
  Schema,
  Loader,
  FlexboxGrid,
} from "rsuite";
import { updateIn } from "json-immut";
import { StringType, NumberType } from "schema-typed";
import { UtilityServices } from "../../../core/services/UtilityServices";
import { UserServices } from "../../../core/services/UserServices";
import { useSelector } from "react-redux";
import { get } from "lodash/fp";
import {
  messageTypeArr,
  orderStatusObj,
  roleTypeArr,
} from "../../../core/config/AppConstants";
import { useTranslation } from "react-i18next";
import React from "react";
import { isNotEmpty } from "../../../utils/helpers";

const AssignOrder = ({
  openModal,
  setOpenModal,
  onAssignOrder,
}: {
  openModal: boolean;
  setOpenModal: any;
  onAssignOrder: Function;
}) => {
  const { t } = useTranslation();
  const selectedCompany = useSelector((state: any) => state.company);
  const formRef = useRef<any>();
  const [assignedTo, setAssignedTo] = useState(null);

  const [isFormSubmitted, setIsFormSubmitted] = useState(false);

  const [assignedToList, setAssignedToList] = useState([]);
  const [formError, setFormError] = useState<any>({});
  const [formData, setFormData] = useState({
    order_assigned_to: null,
  });
  const [loader, setLoader] = useState(false);

  function handleFormChanges(data: any) {
    let form = updateIn(formData, [data.path], data.value);
    setFormData(form);
  }
  async function assignedToSearch(searchStaff: string) {
    let compId: number = 0;
    if (UtilityServices.getLoggedInUser("user_type") == roleTypeArr.client) {
      compId = UtilityServices.getLoggedInUser("company_id");
    } else if (
      UtilityServices.getLoggedInUser("user_type") == roleTypeArr.backend
    ) {
      compId = selectedCompany.id;
    }

    if (!compId) {
      return;
    }
    try {
      const res = await UserServices.getStaffList({
        company: compId.toString(),
        smart_search: searchStaff,
      });
      const respData = get("data.data", res);
      if (respData.length) {
        setAssignedToList(respData);
      }
    } catch (error: any) {
      UtilityServices.showToaster({
        message: error.message,
        type: messageTypeArr.error,
      });
    }
  }
  const formModel = Schema.Model({
    /*order_assigned_to: NumberType().isRequired(
      t("REQUIRED", {
        field:
          t("ORDER") +
          " " +
          t("ASSIGNED").toLowerCase() +
          " " +
          t("TOO").toLowerCase(),
      })
    ),*/
  });

  const orderChangeSubmitted = () => {
    let formFields: any = { ...formData };
    let payload = {
      order_status: orderStatusObj.pending.value,
      order_assigned_to: assignedTo,
    };
    onAssignOrder(payload);
    setOpenModal("");
  };

  useEffect(() => {
    assignedToSearch("");
  }, []);

  return (
    <div className="modal-container">
      <Modal
        open={openModal}
        backdrop={true}
        onClose={(e: any) => {
          setOpenModal("");
        }}
        size="xs"
      >
        {loader && (
          <Loader
            style={{ zIndex: 9999 }}
            size="lg"
            backdrop
            content={t("LOADING")}
            vertical
          />
        )}
        <Modal.Header>
          <h4>
            {t("ASSIGN")} {t("ORDERS")} {t("TO")}
          </h4>
        </Modal.Header>
        <Modal.Body>
          <Container>
            <Content className="edit-cnt">
              <Form
                layout="inline"
                ref={formRef}
                model={formModel}
                formError={formError}
                formDefaultValue={formData}
                onCheck={(e: any) => {
                  setFormError(e);
                }}
                onSubmit={(e: any) => {
                  if (e && assignedTo) {
                    orderChangeSubmitted();
                  }
                }}
                onChange={(data: any) => {
                  let form = { ...formData, ...data };
                  setFormData(form);
                }}
              >
                <FlexboxGrid justify="space-between">
                  <FlexboxGrid.Item>
                    <Form.Group>
                      <CustomSelector
                        loaderMsg={t("LOADING")}
                        name="order_assigned_to"
                        valueKey="id"
                        labelKey="name"
                        defaultValue={assignedTo}
                        customErrorMsg={
                          isFormSubmitted && assignedTo === null
                            ? t("REQUIRED", {
                                field:
                                  t("ASSIGNED") + " " + t("TO").toLowerCase(),
                              })
                            : null
                        }
                        onClear={(event: any) => {
                          setAssignedTo(null);
                          handleFormChanges({
                            path: "order_assigned_to",
                            value: null,
                          });
                        }}
                        listData={assignedToList.length ? assignedToList : []}
                        onSelect={(e: any, selectedObj: any) => {
                          setAssignedTo(e);
                          handleFormChanges({
                            path: "order_assigned_to",
                            value: e,
                          });
                        }}
                      />
                    </Form.Group>
                  </FlexboxGrid.Item>
                </FlexboxGrid>

                <div className="usr-form-btn">
                  <Form.Group>
                    <Button
                      appearance="primary"
                      type="submit"
                      onClick={(e: any) => setIsFormSubmitted(true)}
                    >
                      {t("ASSIGN")}
                    </Button>
                    <Button
                      style={{ marginLeft: "10px" }}
                      onClick={(e: any) => {
                        setIsFormSubmitted(false);
                        setOpenModal("");
                      }}
                      appearance="primary"
                      color="red"
                      type="reset"
                    >
                      {t("CLOSE")}
                    </Button>
                  </Form.Group>
                </div>
              </Form>
            </Content>
          </Container>
        </Modal.Body>
      </Modal>
    </div>
  );
};

export default AssignOrder;
